(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.game_model = svs.numbergames.game_model || {};
svs.numbergames.game_model.models = svs.numbergames.game_model.models || {};
svs.numbergames.game_model.collections = svs.numbergames.game_model.collections || {};
svs.numbergames.game_model.utils = svs.numbergames.game_model.utils || {};
svs.numbergames.game_model.constants = svs.numbergames.game_model.constants || {};
svs.numbergames.game_model.logger = new svs.core.log.Logger('numbergames:game-model');
svs.numbergames.game_model.constants.quickpickStates = {
  ALL_HUXFLUXED: 'Yes (all)',
  PARTIAL_HUXFLUXED: 'Yes (partial)',
  NOT_HUXFLUXED: 'No'
};
svs.numbergames.game_model.rulesRadioChannel = 'numbergames:game-model:rules';

 })(window);